import axios, { AxiosError } from "axios";
import { chatAxios } from "../axios/chatAxios";
import { Brand } from "../context/AppProvider";
import {
  ChatResponse,
  ChatRequest,
  ThumbsResponse,
  ChatHistory,
} from "./models";

export async function chatApi(options: ChatRequest): Promise<ChatResponse> {
  const config = {
    data: {
      history: options.history,
      overrides: {
        semantic_ranker: options.overrides?.semanticRanker,
        semantic_captions: options.overrides?.semanticCaptions,
        top: options.overrides?.top,
        temperature: options.overrides?.temperature,
        chat_record: options.overrides?.chatRecord,
        dummy_answer: options.overrides?.dummyAnswer,
        brand: options.overrides?.brand,
      },
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locale: options.locale,
      conversation_id: options.conversation_id,
      ipGeoLocation: options.ipGeoLocation,
    },
    withCredentials: true,
  };

  try {
    const response = await chatAxios.post("/api/v1/chat", config);
    return response.data as ChatResponse;
  } catch (error: any | AxiosError) {
    throw error;
  }
}

export async function getChatHistory(
  brand: Brand,
  user_id?: number,
  page: number = 1,
  limit: number = 30,
): Promise<ChatHistory> {
  if (!user_id) {
    return {} as ChatHistory;
  }

  try {
    const config = {
      data: {
        brand: brand,
        user_id: user_id,
        page: page,
        limit: limit,
      },
      withCredentials: true,
    };
    const response = await chatAxios.post("/api/v1/chat_history", config);
    return response.data as ChatHistory;
  } catch (e) {
    console.log(e);
    return {} as ChatHistory;
  }
}

/**
 * Increments or decrements the count of thumbs up or thumbs down in MongoDB
 * @param _id unique id of the article stored in MongoDB
 * @param thumbup increase count of thumbs up by given input
 * @param thumbdown increase count of thumbs down by given input
 * @returns Promise<ThumbsResponse[]>
 */
export async function thumbsApi(
  brand: Brand,
  _id: string,
  thumbup: number,
  thumbdown: number,
  feedbackChoices: string[],
  feedbackDetails: string,
): Promise<ThumbsResponse[]> {
  const config = {
    data: {
      brand: brand,
      _id: _id,
      thumbup: thumbup,
      thumbdown: thumbdown,
      feedback_choices: feedbackChoices,
      feedback_details: feedbackDetails,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    withCredentials: true,
  };

  try {
    const response = await chatAxios.post("/api/v1/thumbs", config);
    return response.data as ThumbsResponse[];
  } catch (error) {
    throw error;
  }
}

export async function deleteChatApi(brand: Brand, conversationId: string) {
  const config = {
    data: {
      brand: brand,
      conversationId: conversationId,
    },
    withCredentials: true,
  };
  try {
    await chatAxios.post("/api/v1/delete_chat", config);
  } catch (error) {
    throw error;
  }
}

export async function updateChatNameApi(
  brand: Brand,
  chatId: string,
  newName: string,
) {
  const config = {
    data: {
      brand: brand,
      chatId: chatId,
      newName: newName,
    },
    withCredentials: true,
  };
  try {
    await chatAxios.post("/api/v1/update_chat_name", config);
  } catch (error) {
    throw error;
  }
}

export async function pinChatApi(
  brand: Brand,
  conversationId: string,
  isPinned: boolean,
) {
  const config = {
    data: {
      brand: brand,
      conversationId: conversationId,
      isPinned: isPinned,
    },
    withCredentials: true,
  };
  try {
    await chatAxios.post("/api/v1/pin_chat", config);
  } catch (error) {
    throw error;
  }
}
